var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GeoJsonSource,{ref:"source",attrs:{"data":_setup.url,"source-id":_vm.sourceId}},[_c(_setup.LayerGroup,{attrs:{"hide-layer":_vm.hideLayer,"layers":_setup.layers,"filter":_setup.filter,"before":_setup.props.before,"hover-popup":""},on:{"click":_setup.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }